module.exports = __webpack_public_path__ + "static/img/logo.92b6de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 14